<template>
  <DrawerV2 v-model="visible" size="90%">
    <!-- 左侧：头像（点击不关闭） -->
    <template #header-left>
      <img alt="AI" class="ai-recommend-task-drawer__avatar" :src="avatarImg" @click.stop />
    </template>

    <!-- 居中标题区域：标题 + 副标题 -->
    <template #title>
      <div class="ai-recommend-task-drawer__header-text">
        <div class="ai-recommend-task-drawer__title">
          {{ mainTitle }}
        </div>
        <div class="ai-recommend-task-drawer__subtitle" v-html="subtitle"></div>
      </div>
    </template>

    <!-- 右侧：关闭按钮 -->
    <template #header-right>
      <i
        class="ai-recommend-task-drawer__close icon-close-line t-iconfont"
        @click="visible = false"
      ></i>
    </template>

    <!-- 主体：空状态 -->
    <div class="ai-recommend-task-drawer__body">
      <template v-if="dataList.length > 0">
        <van-list
          v-model:loading="loading"
          class="recommend-data-list"
          :finished="finished"
          finished-text="没有更多了"
          :offset="10"
          @load="getMore"
        >
          <RecommendCard
            v-for="item in dataList"
            :key="item.dataId"
            :card="item"
            @updateList="updateList"
          />
        </van-list>
      </template>

      <div v-else class="empty">
        <Empty empty-text="这里空空如也，快去跟进吧~" />
      </div>
    </div>
  </DrawerV2>
</template>

<script setup>
import { computed, ref, watch, nextTick } from 'vue'
import { List as VanList } from 'vant'
import DrawerV2 from '@/components/drawer-mobile/drawer-v2.vue'
import Empty from '@/components/Empty/index.vue'
import avatarImg from '@/assets/ai-avatar/ai-avatar-2x-11.png'
import { getRecommendedList } from '@/api/app-home.js'
import RecommendCard from './components/recommend-card.vue'

defineOptions({ name: 'RecommendTaskDrawer' })

const visible = defineModel({ type: Boolean, default: false })

const page = ref(1)
const pageSize = ref(10)
const pageTotal = ref(0)
const dataList = ref([])
const taskNum = ref(0)
const customerNum = ref(0)
const loading = ref(false)
const finished = ref(false)

const mainTitle = computed(() => {
  return dataList.value.length > 0 ? '已根据跟进为你提炼推荐任务' : '还没有要推荐的任务哦 ~'
})

const subtitle = computed(() => {
  return dataList.value.length > 0
    ? `<span class="text">共</span>
      <span class="highlight"> ${customerNum.value} </span>
      <span class="text">家客户</span>
      <span class="highlight"> ${taskNum.value} </span>
      <span class="text">条推荐待办，快去跟进吧 ~</span>`
    : '<span class="text">完成跟进后将为你自动提炼，快去跟进吧 ~</span>'
})

watch(visible, (newVal) => {
  if (newVal) {
    page.value = 1
    getList()
  }
})

const updateList = () => {
  page.value = 1
  getList()
}

const getList = async () => {
  // 打开抽屉时初始化第一页
  loading.value = true
  try {
    const res = await getRecommendedList({
      page: page.value,
      pageSize: pageSize.value
    })
    if (page.value === 1) {
      dataList.value = []
      customerNum.value = res.result.customerNum
      taskNum.value = res.result.taskNum
      await nextTick()
      dataList.value = res.result.list
    } else {
      dataList.value = [...dataList.value, ...res.result.list]
    }
    loading.value = false
    pageTotal.value = res.result.pageHelper.pageTotal
    if (page.value >= pageTotal.value) {
      finished.value = true
    }
  } catch (e) {}
}

const getMore = async () => {
  if (page.value >= pageTotal.value) {
    loading.value = false
    return
  }
  page.value++
  getList()
}
</script>

<style lang="scss" scoped>
.ai-recommend-task-drawer {
  &__avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
    border: 1px solid #ffffff;

    box-shadow: 0px 0px 6.67px 0px rgba(56, 47, 220, 0.2);
  }

  &__header-text {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #323233;
  }

  &__subtitle {
    margin-top: 2px;
    :deep(.text) {
      font-size: 13px;
      line-height: 18px;
      color: #969799;
    }
    :deep(.highlight) {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #323233;
    }
  }

  &__close {
    font-size: 20px;
    color: #c9cdd4;
    cursor: pointer;
  }

  &__body {
    display: flex;
    height: 100%;
    position: relative;
    overflow: hidden;
    .recommend-data-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      background: #f3f3f3;
    }
    .empty {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
